import { useMutation, useQueryClient } from "@tanstack/react-query";
import WorkspacesService from "../../../../services/WorkspacesService";
import { COACH_SETTINGS_THEME_QUERY_KEY } from "../../../../routes/coach/settings/theme/CoachSettingsThemeRoute";
import { CURRENT_USER_QUERY_KEY } from "../../../../wrappers/current-user/CurrentUserWrapper";
import { UserInfo } from "../../../../hooks/useCurrentUser";

export const useUpdateProfileCardsPosition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["update-client-profile-cards-position"],
    mutationFn: WorkspacesService.setClientProfileCardsPositions,
    onSuccess: (_, variables) => {
      queryClient.setQueryData([COACH_SETTINGS_THEME_QUERY_KEY], variables);
      queryClient.setQueryData(
        [CURRENT_USER_QUERY_KEY],
        (prev: UserInfo | undefined) => {
          if (!prev) return prev;

          return {
            ...prev,
            workspace: {
              ...prev.workspace,
              profileCardsPositions: variables.clientProfilePositions,
            },
          };
        },
      );
      queryClient.invalidateQueries({ queryKey: [CURRENT_USER_QUERY_KEY] });
    },
  });
};
